export function enableMobileViewport() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (meta) {
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    return;
  }

  const newMeta = document.createElement('meta');
  newMeta.name = 'viewport';
  newMeta.content = 'width=device-width, initial-scale=1.0';
  document.head.appendChild(newMeta);
}

export function removeViewportMeta() {
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  if (!viewportMeta) {
    return false;
  }

  viewportMeta.remove();
  return true;
}
